
























import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref,
} from "vue-property-decorator";

import api from "@/api";
import {BatchCancelInput} from "@/api/appService";
import { ElForm } from "element-ui/types/form";

@Component({
  name: "EditAnchor",
})
export default class EditAnchor extends Vue {
  @Ref() readonly dataForm!: ElForm;

  @Prop({ required: true })
  dataIds!: number[];

  defaultData: BatchCancelInput = {
    ids: [],
    reason: ''
  };

  show = false;
  form: BatchCancelInput = { ...this.defaultData };

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      const loading = this.$loading({
        target: ".el-dialog",
      });

      if (this.dataIds) {
        this.form.ids=this.dataIds;
        setTimeout(() => {
          loading.close();
        }, 200);
      } else {
        this.form = { ...this.defaultData };
        //
        setTimeout(() => {
          loading.close();
        }, 200);
      }
    } else {
      this.form = { ...this.defaultData };
    }

    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  async save() {
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await api.studentBidOrder.batchCancel({body: this.form});
        this.show = false;
        this.$message.success("取消成功");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  linkRule = {
    reason: [
      {
        required: true,
        message: "请输入取消原因",
        trigger: "change",
      },
    ],
  };
}
